document.addEventListener('DOMContentLoaded', function() {
  // --- Utility: Update URL params without reloading ---
  function updateUrlParams(params) {
    const url = new URL(window.location);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null) {
        url.searchParams.set(key, encodeURIComponent(value).replace(/%20/g, '+'));
      } else {
        url.searchParams.delete(key);
      }
    });
    window.history.replaceState({}, '', url);
  }

  // --- Normalize payment method value for URL param ---
  function getNormalizedPaymentMethod(rawValue) {
    if (!rawValue) return '';
    if (rawValue === 'Online') return 'online';
    return rawValue.toLowerCase();
  }

  function isVisible(el) {
    if (!el) return false;

    while (el) {
      const style = getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
      }
      el = el.parentElement;
    }
    return true;
  
  }

  // --- Get current selections from the form ---
  function getCurrentSelections() {
    const values = {
      subscription: false,
      servings: null,
      payment_type: null,
      _paymentMethod: null
    };
  
    // Subscription
    const purchaseRadios = document.querySelectorAll('input[name^="type_of_subscription_"]');
    if (purchaseRadios.length === 1 && isVisible(purchaseRadios[0])) {
      // If only one option, use its value
      values.subscription = purchaseRadios[0].value === 'subscription' ? 'true' : 'false';
    } else {
      // Otherwise use checked radio value
      const purchaseRadio = document.querySelector('input[name^="type_of_subscription_"]:checked');
      if (purchaseRadio && isVisible(purchaseRadio)) {
        values.subscription = purchaseRadio.value === 'subscription' ? 'true' : 'false';
      }
    }
  
    // Servings
    const shipmentSelect = document.querySelector('.product-variant-shipment-amount');
    if (isVisible(shipmentSelect)) {
      const selectedOption = shipmentSelect.options[shipmentSelect.selectedIndex];
      const shipmentAttributeValue = selectedOption?.getAttribute('data-shipment-attribute-value');
      if (shipmentAttributeValue) {
        values.servings = shipmentAttributeValue;
      } else {
        values.servings = selectedOption.value;
      }
    }
  
    // Payment Type
    const paymentTypeSelect = document.querySelector('.product-payment-type--select');
    if (isVisible(paymentTypeSelect)) {
      const selectedOption = paymentTypeSelect.options[paymentTypeSelect.selectedIndex];
      const paymentType = selectedOption?.getAttribute('data-payment-type');
      if (paymentType) values.payment_type = paymentType;
    }
  
    // Payment Method
    const rawPaymentMethodEl = document.querySelector('input[name="payment-method"]:checked');
    if (rawPaymentMethodEl && isVisible(rawPaymentMethodEl)) {
      const normalized = getNormalizedPaymentMethod(rawPaymentMethodEl.value);
      if (normalized) values._paymentMethod = normalized;
    }
    
    return values;
  }
  

  // --- Set form selections from URL params --- 
  function setSelectionsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const paramHandlers = {
      subscription: () => {
        const value = params.get('subscription') === 'true' ? 'subscription' : 'one-time';
        const radio = document.querySelector(`input[name^="type_of_subscription_"][value="${value}"]`);
        if (radio){
          radio.checked = true;
          const changeEvent = new Event('change', {bubbles: true});
          radio.dispatchEvent(changeEvent);
        } 
      },
      servings: () => {
        const select = document.querySelector('.product-variant-shipment-amount');
        const servings = params.get('servings');
        if (select && servings) {
          const matchingOption = Array.from(select.options).find(opt => opt.value.includes(servings));
          if (matchingOption) select.value = matchingOption.value;
        }
      },
      payment_type: () => {
        const select = document.querySelector('.product-payment-type--select');
        const paymentType = params.get('payment_type');
        if (select && paymentType) {
          const option = select.querySelector(`option[data-payment-type="${paymentType}"]`);
          if (option) select.value = option.value;
        }
      },
      _paymentMethod: () => {
        const method = params.get('_paymentMethod');
        if (method) {
          // Try to check the radio button with the normalized value
          let normalized = method.toLowerCase();
          if (normalized === 'online') normalized = 'Online';
          const radio = document.querySelector(`input[name="payment-method"][value="${normalized}"]`)
            || document.querySelector(`input[name="payment-method"][value="${method}"]`);
          if (radio) radio.checked = true;
        }
      }
    };

    Object.keys(paramHandlers).forEach(param => {
      if (params.has(param)) paramHandlers[param]();
    });
  }

  // --- Listen for changes on all relevant inputs ---
  function addListeners() {
    const selectors = {
      'input[name^="type_of_subscription_"]': true,
      '.product-variant-shipment-amount': false,
      '.product-payment-type--select': false,
      'input[name="payment-method"]': true
    };

    for (const [selector, multiple] of Object.entries(selectors)) {
      const elements = multiple ? 
        document.querySelectorAll(selector) : 
        [document.querySelector(selector)].filter(Boolean);

      elements.forEach(el => {
        el.addEventListener('change', () => updateUrlParams(getCurrentSelections()));
      });
    }
  }

  // Initialize
  setSelectionsFromUrl();
  addListeners();
  updateUrlParams(getCurrentSelections());
});